import * as React from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import { darkActionButton } from '../styles/project-styles';
import "./MatiereBox.css";
import "./BlockStructures.css";
import "../index.css";
import { useNavigate } from 'react-router-dom';
import { projectColors } from '../styles/project-styles';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export default function AddLessonModal(props) {

  const [open, setOpen] = React.useState(false);
  const navigate = useNavigate();

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const matieres = ['géographie', 'histoire', 'sciences', 'anglais', 'espagnol', 'mathématiques'];
  return (
    <React.Fragment>
      <Button variant="contained"
        sx={{ ...darkActionButton, width: '70vw' }} onClick={handleClickOpen}>
        Ajouter une leçon
      </Button>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogTitle sx={{ m: 0, p: 2, width: '80vw' }} id="customized-dialog-title">
          Choisis une matière
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          {matieres.map((matiere, index) => {
            return (
              <div className={`matiere-header ${matiere}`} style={{ backgroundColor: projectColors[matiere], marginBottom: '10px', }} key={index} onClick={() => {
                navigate('/new-lesson2', {
                  state: {
                    userMail: props.userMail,
                    matiere: matiere,
                  },
                });
              }}>
                <div className={`matiere-header-circle ${matiere}`} style={{ backgroundColor: 'white', color: projectColors[matiere] }}>{matiere.charAt(0).toUpperCase()}</div>
                <div className="matiere-header-title" style={{ color: 'white' }}>{matiere.toUpperCase()}</div>
              </div>
            );
          }
          )}
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose}>
            Annuler
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </React.Fragment>
  );
}
